import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=414b2c25&scoped=true"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"
import style0 from "./Widgets.vue?vue&type=style&index=0&id=414b2c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414b2c25",
  null
  
)

export default component.exports